import { tv } from 'tailwind-variants';

export const defaultVariants = tv({
  slots: {
    base: 'flex flex-col gap-4',
    seasonButtonsRow: ['flex gap-2 md:gap-7.5 mb-3.5'],
    seasonButtonsWrapper: ['flex-1 basis-0 text-center '],
    seasonButton: [
      'block w-full p-0 border-0 bg-transparent cursor-pointer appearance-none rounded-md',
    ],
    seasonButtonImg: 'block w-full h-auto rounded-md p-1.5 bg-white',
    tableWrapper: 'overflow-x-auto',
    table: [
      'w-full border-collapse',
      '[&_td]:align-middle [&_td]:p-[0.3rem] md:[&_td]:p-2 [&_td]:border-t [&_td]:border-[#dee2e6] [&_td]:font-medium [&_td]:text-textPrimary',
      '[&>tbody>tr:nth-child(odd)>td]:bg-black/5',
      '[&_tr:nth-last-child(-n+2)_td]:border-t-0',
    ],
    kwInput: [
      'my-1.25 w-16.25 text-right bg-white border border-black px-0.5 py-px text-black font-medium',
      'min-[530px]:w-25',
    ],
    totalInput: ['w-25'],
    textboxTitle: 'text-textPrimary text-nowrap font-bold!',
    switchLabel: 'relative inline-block cursor-pointer align-middle',
    switchInput: 'peer absolute w-px h-px opacity-0 overflow-hidden m-0 pointer-events-none',
    switchTrack: [
      'block w-19.5 md:w-26.5 h-auto rounded overflow-hidden border border-[#cccccc] bg-[#eeeeee]',
      'peer-focus-visible:border-[#0062cc]',
      'peer-focus-visible:shadow-[0_0_0_0.2rem_rgba(38,143,255,0.5)]',
    ],
    switchInner: 'flex h-full min-w-32.5 md:min-w-39 transition-transform duration-300 ease-in-out',
    switchOn: [
      'w-13 shrink-0 px-3 py-1.5',
      'flex items-center justify-center text-sm font-medium leading-5',
      'bg-[#337ab7] text-white',
    ],
    switchKnob: 'block min-w-6.5 md:min-w-13 shrink-0 px-3 py-1.5 bg-white',
    switchOff: [
      'w-13 shrink-0 px-3 py-1.5',
      'flex items-center justify-center text-sm font-medium leading-5',
      'text-black',
    ],
    resetButton: [
      'inline-flex items-center justify-center gap-2 font-medium transition-all duration-300',
      'cursor-pointer w-fit rounded px-2 py-1.5 text-base leading-normal no-underline',
      'border-0 bg-primary text-white hover:bg-tertiary',
    ],
    footNote: '**:text-base **:font-medium md:**:font-light',
  },
  variants: {
    isOn: {
      true: { switchInner: 'translate-x-0' },
      false: { switchInner: '-translate-x-13' },
    },
  },
  defaultVariants: {
    isOn: false,
  },
});
